import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';
import { Loading } from '@cotera/client/app/components';

/**
 * A channel-mapped agent runs as the org's bot user, which can only reach
 * resources the org shares. When the selected agent isn't shared yet, the
 * caller confirms the org-wide share here before the assignment is saved.
 */
export const ShareAgentWithOrgDialog: React.FC<{
  open: boolean;
  agentName: string;
  isSharing: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}> = ({ open, agentName, isSharing, onOpenChange, onConfirm }) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Share agent with your organization?</DialogTitle>
          <DialogDescription>
            {agentName} isn&apos;t shared with your organization yet. The bot
            answers in shared channels on behalf of the whole org, so it can
            only run agents the org can see. Sharing gives everyone in your
            organization view access to this agent.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            disabled={isSharing}
            onClick={() => onOpenChange(false)}
          >
            Cancel
          </Button>
          <Button disabled={isSharing} onClick={onConfirm}>
            {isSharing ? (
              <>
                <Loading.Spinner variant="sm" />
                Sharing...
              </>
            ) : (
              'Share and assign'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
